import * as THREE from "three";

/**
 * Applies strict token-based material overrides on a loaded scene.
 * Only handles material name matching and replacement.
 */
export function applyMaterialOverrides(scene, { renderEnabled = true } = {}) {
  if (!scene) return;

  const MATERIAL_LIBRARY = [
    {
      token: "~RefractiveR~",
      create: () =>
        new THREE.MeshPhysicalMaterial({
          color: 0xffffff,
          metalness: 0,
          roughness: 0.6, // rough refractive
          transmission: 1.0,
          thickness: 3.0,
          ior: 1.5,
          envMapIntensity: 2.0,
          transparent: true,
        }),
    },
    {
      token: "~RefractiveS~",
      create: () =>
        new THREE.MeshPhysicalMaterial({
          color: 0xffffff,
          metalness: 0,
          roughness: 0.05, // sharp refractive
          transmission: 1.0,
          thickness: 3.0,
          ior: 1.5,
          envMapIntensity: 2.5,
          transparent: true,
        }),
    },
  ];

  scene.traverse((child) => {
    if (!child.isMesh) return;

    child.castShadow = !!renderEnabled;
    child.receiveShadow = !!renderEnabled;

    const materials = Array.isArray(child.material)
      ? child.material
      : [child.material];

    materials.forEach((mat, index) => {
      if (!mat?.name) return;
      if (mat.name.endsWith("_OVERRIDE")) return;

      const override = MATERIAL_LIBRARY.find((entry) =>
        mat.name.includes(entry.token),
      );

      if (!override) return;

      const newMaterial = override.create();
      newMaterial.name = mat.name + "_OVERRIDE";
      newMaterial.needsUpdate = true;

      if (Array.isArray(child.material)) {
        child.material[index] = newMaterial;
      } else {
        child.material = newMaterial;
      }
    });
  });
}
